import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Text } from '../Text';
import styles from './LearnMore.module.scss';
type Props = {
  className?: string;
};
export const LearnMore = ({
  className
}: Props) => {
  const pathname = usePathname();
  return <Link className={clsx(styles.wrapper, className)} href={`/auth/sign-in?callbackUrl=${pathname}`} data-sentry-element="Link" data-sentry-component="LearnMore" data-sentry-source-file="LearnMore.tsx">
      <Text type='p3' data-sentry-element="Text" data-sentry-source-file="LearnMore.tsx">Дізнатись більше</Text>
    </Link>;
};